import React, { useEffect } from "react";

import { API_BASE_URL } from "../config";

const LoginModal = ({ isOpen, onClose }) => {
    // 1. Hooks must be called unconditionally
    useEffect(() => {
        const handleEsc = (e) => {
            if (isOpen && e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);

    // 2. Early return AFTER hooks
    if (!isOpen) return null;

    // Prevent click propagation from modal content to backdrop
    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    const handleLogin = (provider) => {
        const next = encodeURIComponent(window.location.origin);
        window.location.href = `${API_BASE_URL}/auth/login/${provider}?next=${next}`;
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-content panel" onClick={handleContentClick}>
                <button className="modal-close-btn" onClick={onClose}>
                    &times;
                </button>

                <h2>Welcome Back</h2>
                <p className="tag">Sign in to continue</p>

                <div className="auth-buttons-container">
                    <button
                        className="button auth-btn google-btn"
                        onClick={() => handleLogin('google')}
                    >
                        <span className="icon">G</span> Sign in with Google
                    </button>

                    <button
                        className="button auth-btn github-btn"
                        onClick={() => handleLogin('github')}
                    >
                        <span className="icon">GH</span> Sign in with GitHub
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoginModal;
